import {
  FloatingBackButton,
  PageBackground,
  LogoBannerImage,
  Button,
} from "globalComponents";
import React from "react";
import styled from "styled-components";
import Logo from "../../assets/logos/banner.png";
import { useHistory, useParams } from "react-router-dom";
import {
  Container,
  Title,
  StyledForm,
  SubmitButton,
  ButtonContent,
  Label,
  Input,
  Checkbox,
} from "globalComponents/FormComponents";
import axios from "axios";
import { errorHandler } from "globalResources/util";
import { isEmail } from "globalResources/validators";
import cookie from "js-cookie";
import { getTheme } from "Theme";
import { rememberInviteCode } from "./session";
const theme = getTheme();

const DisclaimerText = styled.p`
  font-size: 0.9em;
`;

const Link = styled.a`
  color: ${theme.TEXT_HIGHLIGHT};
  text-decoration: underline;
`;

const RootUser = () => {
  const history = useHistory();
  const { user } = useParams();
  const token = cookie.get("token");
  const [form, setForm] = React.useState({
    email: "",
    phone: "",
    firstName: "",
    lastName: "",
  });
  const [submitEnabled, setSubmitEnabled] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState(null);

  // invite links (/onboarding/root?joinCode=...) prefill the later join step
  React.useEffect(() => {
    rememberInviteCode(
      new URLSearchParams(window.location.search).get("joinCode"),
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isEmail(form.email)) {
      setError("A valid email is required");
      return;
    } else if (!form.firstName) {
      setError("First Name is required");
      return;
    } else if (!form.lastName) {
      setError("Last Name is required");
      return;
    } else if (!form.agree) {
      setError("You must agree to the terms to create an account");
    } else {
      setError(null);

      try {
        await axios.post("/root/user", { ...form });
        setSuccess(true);
      } catch (error) {
        const errRes = await errorHandler(error);
        setError(errRes.message);
        console.error("Error creating root user:", error);
      }
    }
  };

  if (token) {
    return (
      <PageBackground>
        <LogoBannerImage src={Logo} alt="Logo" />
        <h1>You are already logged in</h1>
        <p>
          Log out of your account to create a new one or head to the dashboard
          to get started.
        </p>
        <div
          style={{
            display: "flex",
            gap: 10,
            flexDirection: "row",
            width: "80vw",
            justifyContent: "center",
          }}
        >
          <Button onClick={() => history.push("/dashboard")}>
            Go to Dashboard
          </Button>
          <Button
            color={theme.NEGATIVE}
            onClick={() => history.push("/logout")}
          >
            Logout
          </Button>
        </div>
      </PageBackground>
    );
  }
  if (success) {
    return (
      <PageBackground>
        <FloatingBackButton onClick={() => history.push("/")}>
          Home
        </FloatingBackButton>
        <LogoBannerImage src={Logo} alt="Logo" />
        <h1>Success!</h1>
        <p>Your account has been created.</p>
        <p>
          Please check your email to login. (If you don't see it, check your
          spam folder.)
        </p>
      </PageBackground>
    );
  }

  return (
    <PageBackground>
      <FloatingBackButton onClick={() => history.goBack()}>
        Back
      </FloatingBackButton>
      <LogoBannerImage src={Logo} alt="Logo" />
      <Container>
        <Title>Create Your Account</Title>
        <StyledForm>
          <Label>Email</Label>
          <Input
            type="email"
            placeholder="Email"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <Label>
            Phone Number <i style={{ fontSize: 12 }}>(optional)</i>
          </Label>
          <Input
            type="tel"
            placeholder="Phone Number"
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
          <Label>First Name</Label>
          <Input
            type="text"
            placeholder="John"
            onChange={(e) => setForm({ ...form, firstName: e.target.value })}
          />
          <Label>Last Name</Label>
          <Input
            type="text"
            placeholder="Doe"
            onChange={(e) => setForm({ ...form, lastName: e.target.value })}
          />
          <DisclaimerText>
            By selecting "I Agree" below, you agree to our{" "}
            <Link href="/terms" target="_blank">
              Terms of Service
            </Link>{" "}
            and
            <Link href="/privacy" target="_blank">
              {" "}
              Privacy Policy
            </Link>
            . As well as receive SMS notifications from TCS for the purpose of
            account security, login verification, customer support and TCS
            related user services. Message and data rates may apply. You may opt
            out at any time by replying STOP to any message. for details on our
            messaging practices and how to opt-out, please visit our{" "}
            <Link href="/messaging" target="_blank">
              SMS Opt in Details
            </Link>
            .
          </DisclaimerText>
          <Checkbox
            label="I Agree"
            value={form.agree}
            onCheck={() => setForm({ ...form, agree: !form.agree })}
          />
          {error && <p style={{ color: "red" }}>{error}</p>}
          <SubmitButton onClick={handleSubmit}>
            <ButtonContent>Create User</ButtonContent>
          </SubmitButton>
        </StyledForm>
      </Container>
    </PageBackground>
  );
};
export default RootUser;
